export const SearchIcon = ({ color = "#8E98C7" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <mask
        id="mask0_0_7184"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="25"
      >
        <rect y="0.5" width="24" height="24" fill={color} />
      </mask>
      <g mask="url(#mask0_0_7184)">
        <path
          d="M19.5423 21.077L13.2616 14.796C12.7616 15.2088 12.1866 15.5319 11.5366 15.7653C10.8866 15.9986 10.2141 16.1153 9.5193 16.1153C7.81014 16.1153 6.36364 15.5235 5.1798 14.34C3.99597 13.1565 3.40405 11.7103 3.40405 10.0015C3.40405 8.29285 3.9958 6.84618 5.1793 5.66152C6.3628 4.47702 7.80897 3.88477 9.5178 3.88477C11.2265 3.88477 12.6731 4.47668 13.8578 5.66051C15.0423 6.84435 15.6346 8.29085 15.6346 10C15.6346 10.7142 15.5147 11.3963 15.2751 12.0463C15.0352 12.6963 14.7153 13.2616 14.3153 13.7423L20.5961 20.023L19.5423 21.077ZM9.5193 14.6155C10.8078 14.6155 11.8991 14.1683 12.7933 13.274C13.6876 12.3798 14.1348 11.2885 14.1348 10C14.1348 8.71152 13.6876 7.62018 12.7933 6.72601C11.8991 5.83168 10.8078 5.38452 9.5193 5.38452C8.2308 5.38452 7.13947 5.83168 6.2453 6.72601C5.35097 7.62018 4.9038 8.71152 4.9038 10C4.9038 11.2885 5.35097 12.3798 6.2453 13.274C7.13947 14.1683 8.2308 14.6155 9.5193 14.6155Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export const CloseIcon = ({ color = "#ABB2CF" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
  >
    <path
      d="M1.05378 9.67305L0.327026 8.9463L4.27303 5.00005L0.327026 1.0788L1.05378 0.352051L5.00003 4.29805L8.92128 0.352051L9.64803 1.0788L5.70203 5.00005L9.64803 8.9463L8.92128 9.67305L5.00003 5.72705L1.05378 9.67305Z"
      fill={color}
    />
  </svg>
);

export const SidebarCloseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M7 7.5H17C17.8284 7.5 18.5 8.17157 18.5 9V15C18.5 15.8284 17.8284 16.5 17 16.5H7C6.17157 16.5 5.5 15.8284 5.5 15V9C5.5 8.17157 6.17157 7.5 7 7.5Z"
        stroke="#242424"
      />
    </svg>
  );
};
export const SidebarOpenIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="9"
      viewBox="0 0 14 9"
      fill="none"
    >
      <path
        d="M12 0.5C12.8284 0.5 13.5 1.17157 13.5 2V7C13.5 7.82843 12.8284 8.5 12 8.5H4.5V0.5H12Z"
        stroke="#242424"
      />
      <path
        d="M2 0.5H4.5V8.5H2C1.17157 8.5 0.5 7.82843 0.5 7V2C0.5 1.17157 1.17157 0.5 2 0.5Z"
        stroke="#242424"
      />
    </svg>
  );
};

export const ComputerIcon = ({ color = "#242424" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="16"
      viewBox="0 0 22 16"
      fill="none"
    >
      <path
        d="M0.769257 15.4614V14.4614H21.2308V15.4614H0.769257ZM3.61551 13.4614C3.15517 13.4614 2.77084 13.3073 2.46251 12.9989C2.15417 12.6906 2.00001 12.3063 2.00001 11.8462V2.07693C2.00001 1.61659 2.15417 1.23226 2.46251 0.923926C2.77084 0.615592 3.15517 0.461426 3.61551 0.461426H18.3845C18.8448 0.461426 19.2292 0.615592 19.5375 0.923926C19.8458 1.23226 20 1.61659 20 2.07693V11.8462C20 12.3063 19.8458 12.6906 19.5375 12.9989C19.2292 13.3073 18.8448 13.4614 18.3845 13.4614H3.61551ZM3.61551 12.4614H18.3845C18.5385 12.4614 18.6796 12.3973 18.8078 12.2692C18.9359 12.141 19 12 19 11.8462V2.07693C19 1.92309 18.9359 1.78201 18.8078 1.65368C18.6796 1.52551 18.5385 1.46143 18.3845 1.46143H3.61551C3.46151 1.46143 3.32042 1.52551 3.19226 1.65368C3.06409 1.78201 3.00001 1.92309 3.00001 2.07693V11.8462C3.00001 12 3.06409 12.141 3.19226 12.2692C3.32042 12.3973 3.46151 12.4614 3.61551 12.4614Z"
        fill={color}
      />
    </svg>
  );
};

export const CorporateFare = ({ color = "#242424" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="18"
      viewBox="0 0 24 18"
      fill="none"
    >
      <path
        d="M0.916138 17.5V0.5H9.91614V4.5H19.4546V17.5H0.916138ZM1.91614 16.5H8.91614V13.5H1.91614V16.5ZM1.91614 12.5H8.91614V9.5H1.91614V12.5ZM1.91614 8.5H8.91614V5.5H1.91614V8.5ZM1.91614 4.5H8.91614V1.5H1.91614V4.5ZM9.91614 16.5H18.4546V5.5H9.91614V16.5ZM12.3009 9.5V8.5H15.6854V9.5H12.3009ZM12.3009 13.5V12.5H15.6854V13.5H12.3009Z"
        fill={color}
      />
      <path
        d="M22.0839 13.6543V5.6543H23.0839V13.6543H22.0839ZM22.0839 17.5003V16.5003H23.0839V17.5003H22.0839Z"
        fill={color}
      />
    </svg>
  );
};

export const Architectural = ({ color = "#242424" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="21"
      viewBox="0 0 22 21"
      fill="none"
    >
      <path
        d="M7.96849 4.4779H21V19.8917H3.5C2.66667 19.8917 1 19.3917 1 17.3917M1 17.3917C1 14.8917 2.6048 14.6086 3.25015 14.6086C3.83461 14.6086 4.63216 14.7121 5.5 15.8917C5.5 15.0917 5.4291 7.01673 5.4291 3.01673C5.4291 1.92685 4.80136 0.881348 3.20136 0.881348C1.3689 0.881348 1 2.44435 1 3.66524C1 4.06524 1 13.725 1 17.3917Z"
        stroke={color}
      />
      <path
        d="M7.95312 8.52602H10.6108M19.48 8.52602H11.7178M7.95312 17H12M15.5 17.0001L12 17M7.95312 11.3052H8.87987L15.5 11.3053M17.7106 10.5V17.5156M12 17V11.5M11.7028 8.5L11.7178 8.52602M11.7178 8.52602H10.6108M10.6108 8.52602V6.1463M17.0395 8.52602V6.1463M19.5 15H17.7594M2.32611 12H0.792236M2.32618 8.5H0.792311M2.32618 5.18994H0.792311"
        stroke={color}
      />
    </svg>
  );
};

export const SlideShow = ({ color = "#242424" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M5.8845 11.577L11.4615 8L5.8845 4.423V11.577ZM1.6155 16C1.15517 16 0.770833 15.8458 0.4625 15.5375C0.154167 15.2292 0 14.8448 0 14.3845V1.6155C0 1.15517 0.154167 0.770833 0.4625 0.4625C0.770833 0.154167 1.15517 0 1.6155 0H14.3845C14.8448 0 15.2292 0.154167 15.5375 0.4625C15.8458 0.770833 16 1.15517 16 1.6155V14.3845C16 14.8448 15.8458 15.2292 15.5375 15.5375C15.2292 15.8458 14.8448 16 14.3845 16H1.6155ZM1.6155 15H14.3845C14.5385 15 14.6796 14.9359 14.8077 14.8077C14.9359 14.6796 15 14.5385 15 14.3845V1.6155C15 1.4615 14.9359 1.32042 14.8077 1.19225C14.6796 1.06408 14.5385 1 14.3845 1H1.6155C1.4615 1 1.32042 1.06408 1.19225 1.19225C1.06408 1.32042 1 1.4615 1 1.6155V14.3845C1 14.5385 1.06408 14.6796 1.19225 14.8077C1.32042 14.9359 1.4615 15 1.6155 15Z"
        fill={color}
      />
    </svg>
  );
};

export const Man = ({ color = "#1C1B1F" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="20"
      viewBox="0 0 8 20"
      fill="none"
    >
      <path
        d="M1.76925 19.077V12.5H0V6.6155C0 6.17117 0.158167 5.79083 0.4745 5.4745C0.790834 5.15817 1.17117 5 1.6155 5H5.4615C5.90583 5 6.28617 5.15817 6.6025 5.4745C6.91883 5.79083 7.077 6.17117 7.077 6.6155V12.5H5.30775V19.077H1.76925ZM3.5385 3.38475C3.07317 3.38475 2.67475 3.219 2.34325 2.8875C2.01192 2.55617 1.84625 2.15783 1.84625 1.6925C1.84625 1.227 2.01192 0.828584 2.34325 0.49725C2.67475 0.16575 3.07317 0 3.5385 0C4.00383 0 4.40225 0.16575 4.73375 0.49725C5.06508 0.828584 5.23075 1.227 5.23075 1.6925C5.23075 2.15783 5.06508 2.55617 4.73375 2.8875C4.40225 3.219 4.00383 3.38475 3.5385 3.38475Z"
        fill={color}
      />
    </svg>
  );
};

export const ThreeDCube = ({ color = "black" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="23"
      viewBox="0 0 21 23"
      fill="none"
    >
      <path
        d="M14.0093 8.24316V17.1318L5.07764 15.3047L4.89697 6.4541L14.0093 8.24316Z"
        stroke={color}
        strokeWidth="1.2"
      />
      <path d="M5 15.3872L13.9062 10.356" stroke={color} strokeWidth="1.2" />
      <path
        d="M19.2915 3.86475L14.7905 6.42236L6.00146 4.64404L10.7749 2.32959L19.2915 3.86475Z"
        stroke={color}
      />
      <path
        d="M20.0811 13.6177L16.0625 16.6362V7.8042L20.2607 5.34814L20.0811 13.6177Z"
        stroke={color}
      />
      <path
        d="M14.6089 17.8677L12.8687 17.5112L14.6089 16.5073V17.8677ZM13.1655 16.3472L11.5991 17.2515L9.81885 16.8872L11.3862 15.9829L13.1655 16.3472ZM10.1157 15.7231L8.54932 16.6274L6.76904 16.2632L8.33643 15.3589L10.1157 15.7231ZM14.6089 15.5142L13.4087 16.2065V14.8149L14.6089 14.1226V15.5142ZM5.66748 14.813L7.06689 15.0991L5.49854 16.0034L4.48779 15.7974L4.4751 15.2026L5.66064 14.5181L5.66748 14.813ZM5.64111 13.5366L4.45557 14.2222L4.42725 12.8462L5.61279 12.1616L5.64111 13.5366ZM14.6089 13.1294L13.4087 13.8218V12.4302L14.6089 11.7378V13.1294ZM5.59326 11.1802L4.40674 11.8647L4.37842 10.4897L5.56494 9.8042L5.59326 11.1802ZM14.6089 10.7446L13.4087 11.437V10.0454L14.6089 9.35303V10.7446ZM5.54541 8.82275L4.35889 9.50732L4.33057 8.13232L5.51709 7.44775L5.54541 8.82275ZM14.6089 7.75049V8.35986L13.4087 9.05322V8.73779L12.0171 8.46436L13.5972 7.55127L14.6089 7.75049ZM12.314 7.29932L10.7339 8.2124L8.93506 7.85889L10.5151 6.94678L12.314 7.29932ZM9.23096 6.69482L7.65088 7.60693L5.85303 7.25342L7.43311 6.34131L9.23096 6.69482ZM6.14795 6.08936L4.31006 7.1499L4.28271 5.77588L4.3501 5.73584L6.14795 6.08936Z"
        fill="white"
      />
      <path
        d="M14.5088 7.83203V17.7441L4.58594 15.7148L4.38379 5.84375L14.5088 7.83203Z"
        stroke={color}
        strokeWidth="0.2"
      />
      <path
        d="M13.3374 8.74951V16.3667L5.71045 14.8071L5.55518 7.22119L13.3374 8.74951Z"
        stroke={color}
        strokeWidth="0.2"
      />
      <path
        d="M17.9844 4.04004V21.125L0.859375 17.623L0.511719 0.609375L17.9844 4.04004Z"
        fill={color}
        fillOpacity="0.2"
        stroke={color}
      />
    </svg>
  );
};

export const SquareFillTop = ({ color = "black" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
    >
      <path
        d="M9.82715 6.91504V16.0088L0.696289 14.1406L0.511719 5.08594L9.82715 6.91504Z"
        stroke={color}
      />
      <path
        d="M16.0732 2.05566L10.6133 5.16895L1.7998 3.38672L7.55664 0.520508L16.0732 2.05566Z"
        fill={color}
        fillOpacity="0.2"
        stroke={color}
      />
      <path
        d="M16.8608 11.8066L11.7251 15.6094V6.76465L17.0396 3.55371L16.8608 11.8066Z"
        stroke={color}
      />
    </svg>
  );
};
export const SquareFillTopBack = ({ color = "black" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
    >
      <path
        d="M17.1216 2.24219L16.8765 11.5059L8.03076 9.80469L7.98193 0.598633L17.1216 2.24219Z"
        fill={color}
        fillOpacity="0.2"
        stroke={color}
      />
      <path
        d="M9.82715 6.91895V16.0127L0.694336 14.1416L0.511719 5.08984L9.82715 6.91895Z"
        stroke={color}
      />
      <path
        d="M16.0732 2.05957L10.6133 5.17285L1.7998 3.39062L7.55664 0.524414L16.0732 2.05957Z"
        stroke={color}
      />
      <path
        d="M16.8608 11.8555L11.7251 15.6182V6.76855L17.0396 3.55762L16.8608 11.8555Z"
        stroke={color}
      />
    </svg>
  );
};
export const SquareFillBottomFront = ({ color = "black" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
    >
      <path
        d="M9.82715 6.91455V16.0083L0.694336 14.1372L0.511719 5.08545L9.82715 6.91455Z"
        fill={color}
        fillOpacity="0.2"
        stroke={color}
      />
      <path
        d="M16.0732 2.05566L10.6133 5.16895L1.7998 3.38672L7.55664 0.520508L16.0732 2.05566Z"
        stroke={color}
      />
      <path
        d="M16.8608 11.8516L11.7251 15.6143V6.76465L17.0396 3.55371L16.8608 11.8516Z"
        stroke={color}
      />
    </svg>
  );
};
export const SquareFill = ({ color = "black" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
    >
      <path
        d="M9.82715 6.91455V16.0083L0.694336 14.1372L0.511719 5.08545L9.82715 6.91455Z"
        fill={color}
        fillOpacity="0.2"
        stroke={color}
      />
      <path
        d="M16.0732 2.05566L10.6133 5.16895L1.7998 3.38672L7.55664 0.520508L16.0732 2.05566Z"
        fill={color}
        fillOpacity="0.2"
        stroke={color}
      />
      <path
        d="M16.8608 11.8359L11.7251 15.6123V6.76465L17.0396 3.55371L16.8608 11.8359Z"
        fill={color}
        fillOpacity="0.2"
        stroke={color}
      />
    </svg>
  );
};

export const Map = ({ color = "#1C1B1F" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="18"
      viewBox="0 0 12 18"
      fill="none"
    >
      <path
        d="M6 18C4.38717 18 3.06733 17.7942 2.0405 17.3825C1.0135 16.971 0.5 16.4397 0.5 15.7885C0.5 15.4782 0.6465 15.181 0.9395 14.897C1.23233 14.6132 1.63392 14.3718 2.14425 14.173L2.93075 14.8405C2.65258 14.9455 2.36508 15.0846 2.06825 15.2578C1.77142 15.4308 1.58583 15.6013 1.5115 15.7693C1.62567 16.1001 2.10967 16.3879 2.9635 16.6327C3.81733 16.8776 4.82633 17 5.9905 17C7.1545 17 8.16758 16.8776 9.02975 16.6327C9.89192 16.3879 10.3801 16.1001 10.4943 15.7693C10.4418 15.5974 10.2501 15.425 9.91925 15.252C9.58842 15.0788 9.27558 14.9397 8.98075 14.8345L9.7615 14.1615C10.318 14.3642 10.7468 14.6074 11.048 14.8913C11.3493 15.1753 11.5 15.4714 11.5 15.7797C11.5 16.4336 10.9865 16.9671 9.9595 17.3803C8.93267 17.7934 7.61283 18 6 18ZM6.025 13.75C7.68783 12.4563 8.93267 11.1907 9.7595 9.953C10.5865 8.71517 11 7.49875 11 6.30375C11 4.55308 10.4615 3.23142 9.3845 2.33875C8.30767 1.44625 7.18267 1 6.0095 1C4.8365 1 3.70833 1.44675 2.625 2.34025C1.54167 3.23375 1 4.55683 1 6.3095C1 7.46083 1.4115 8.65033 2.2345 9.878C3.05767 11.1055 4.32117 12.3962 6.025 13.75ZM6 15C3.98567 13.4703 2.48208 11.9847 1.48925 10.5433C0.496417 9.10175 0 7.68967 0 6.307C0 5.26267 0.180417 4.34908 0.54125 3.56625C0.90225 2.78358 1.37117 2.1275 1.948 1.598C2.525 1.0685 3.17025 0.669834 3.88375 0.402C4.59725 0.134 5.30367 0 6.003 0C6.70233 0 7.40775 0.134 8.11925 0.402C8.83075 0.669834 9.475 1.0685 10.052 1.598C10.6288 2.1275 11.0977 2.78417 11.4587 3.568C11.8196 4.35167 12 5.26358 12 6.30375C12 7.68692 11.5036 9.0995 10.5107 10.5415C9.51792 11.9835 8.01433 13.4697 6 15ZM6.0095 7.7885C6.45067 7.7885 6.82858 7.63433 7.14325 7.326C7.45808 7.01767 7.6155 6.63658 7.6155 6.18275C7.6155 5.72892 7.45725 5.34458 7.14075 5.02975C6.82442 4.71508 6.44417 4.55775 6 4.55775C5.56533 4.55775 5.18742 4.71592 4.86625 5.03225C4.54508 5.34858 4.3845 5.72883 4.3845 6.173C4.3845 6.63333 4.54508 7.01767 4.86625 7.326C5.18742 7.63433 5.5685 7.7885 6.0095 7.7885Z"
        fill={color}
      />
    </svg>
  );
};

export const Ruler = ({ color = "#1C1B1F" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="21"
      viewBox="0 0 18 21"
      fill="none"
    >
      <path
        d="M4.30775 8.577L0 4.2885L4.2885 0L4.99625 0.688501L1.92125 3.76925H16.0788L13.0038 0.688501L13.7115 0L18 4.2885L13.7115 8.577L12.9845 7.8885L16.0788 4.7885H1.902L4.99625 7.8885L4.30775 8.577Z"
        fill={color}
      />
      <path
        d="M1.6155 20.5771C1.15517 20.5771 0.770833 20.423 0.4625 20.1146C0.154167 19.8063 0 19.422 0 18.9616V12.1926C0 11.7323 0.154167 11.348 0.4625 11.0396C0.770833 10.7313 1.15517 10.5771 1.6155 10.5771H16.3845C16.8448 10.5771 17.2292 10.7313 17.5375 11.0396C17.8458 11.348 18 11.7323 18 12.1926V18.9616C18 19.422 17.8458 19.8063 17.5375 20.1146C17.2292 20.423 16.8448 20.5771 16.3845 20.5771H1.6155ZM1.6155 19.5771H16.3845C16.5385 19.5771 16.6796 19.5131 16.8078 19.3849C16.9359 19.2567 17 19.1156 17 18.9616V12.1926C17 12.0386 16.9359 11.8976 16.8078 11.7694C16.6796 11.6412 16.5385 11.5771 16.3845 11.5771H13.5V14.8079H12.5V11.5771H9.5V14.8079H8.5V11.5771H5.5V14.8079H4.5V11.5771H1.6155C1.4615 11.5771 1.32042 11.6412 1.19225 11.7694C1.06408 11.8976 1 12.0386 1 12.1926V18.9616C1 19.1156 1.06408 19.2567 1.19225 19.3849C1.32042 19.5131 1.4615 19.5771 1.6155 19.5771Z"
        fill={color}
      />
    </svg>
  );
};
export const RulerYAxis = ({ color = "#1C1B1F" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="18"
      viewBox="0 0 21 18"
      fill="none"
    >
      <path
        d="M8.577 13.6923L4.2885 18L5.99349e-07 13.7115L0.688502 13.0038L3.76925 16.0788L3.76925 1.92125L0.688501 4.99625L1.87456e-07 4.2885L4.2885 7.11994e-07L8.577 4.2885L7.8885 5.0155L4.7885 1.92125L4.7885 16.098L7.8885 13.0038L8.577 13.6923Z"
        fill={color}
      />
      <path
        d="M20.577 16.3845C20.577 16.8448 20.4229 17.2292 20.1145 17.5375C19.8062 17.8458 19.4219 18 18.9615 18L12.1925 18C11.7322 18 11.3479 17.8458 11.0395 17.5375C10.7312 17.2292 10.577 16.8448 10.577 16.3845L10.577 1.6155C10.577 1.15517 10.7312 0.770833 11.0395 0.4625C11.3479 0.154168 11.7322 8.48956e-07 12.1925 8.28835e-07L18.9615 5.32952e-07C19.4219 5.1283e-07 19.8062 0.154168 20.1145 0.4625C20.4229 0.770833 20.577 1.15517 20.577 1.6155L20.577 16.3845ZM19.577 16.3845L19.577 1.6155C19.577 1.4615 19.5129 1.32042 19.3848 1.19225C19.2566 1.06408 19.1155 1 18.9615 1L12.1925 1C12.0385 1 11.8974 1.06408 11.7693 1.19225C11.6411 1.32042 11.577 1.4615 11.577 1.6155L11.577 4.5L14.8078 4.5L14.8078 5.5L11.577 5.5L11.577 8.5L14.8078 8.5L14.8078 9.5L11.577 9.5L11.577 12.5L14.8078 12.5L14.8078 13.5L11.577 13.5L11.577 16.3845C11.577 16.5385 11.6411 16.6796 11.7693 16.8078C11.8974 16.9359 12.0385 17 12.1925 17L18.9615 17C19.1155 17 19.2566 16.9359 19.3848 16.8078C19.5129 16.6796 19.577 16.5385 19.577 16.3845Z"
        fill={color}
      />
    </svg>
  );
};
export const HomeIcon = ({ color = "#1C1B1F" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
    >
      <path
        d="M1 14.7885H4.69225V8.904H9.30775V14.7885H13V5.7885L7 1.25L1 5.7885V14.7885ZM0 15.7885V5.2885L7 0L14 5.2885V15.7885H8.30775V9.904H5.69225V15.7885H0Z"
        fill={color}
      />
    </svg>
  );
};

export const CameraIcon = ({ color = "#242424" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
    >
      <path
        d="M11.082 8.20309L10.0033 7.58775L12.2769 5.9262L13.3333 6.54153L11.082 8.20309ZM7.51444 6.77397L10.4411 4.64242L3.74356 0.938196C3.61822 0.869752 3.4843 0.852641 3.34178 0.886863C3.19941 0.921085 3.0883 1.00086 3.00844 1.1262L1.89733 3.00997C1.81763 3.14672 1.7977 3.28916 1.83756 3.43731C1.87741 3.58546 1.96578 3.69938 2.10267 3.77909L7.51444 6.77397ZM0 12.4082V11.5193H3.72644C3.886 11.5193 4.01704 11.468 4.11956 11.3655C4.22222 11.2629 4.27356 11.1318 4.27356 10.9722V5.99109L1.67511 4.54331C1.31393 4.34835 1.08178 4.05746 0.978667 3.67064C0.875555 3.28368 0.927111 2.91531 1.13333 2.56553L2.22733 0.715974C2.42215 0.377455 2.70733 0.156641 3.08289 0.0535296C3.45844 -0.0495815 3.81541 -0.00372963 4.15378 0.191085L12.0564 4.56709L7.57444 7.82531L5.14533 6.48864V10.9722C5.14533 11.37 5.00541 11.7088 4.72556 11.9886C4.44585 12.2683 4.10711 12.4082 3.70933 12.4082H0Z"
        fill={color}
      />
    </svg>
  );
};

export const SimulationIcon = ({ color = "#242424" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="13"
      viewBox="0 0 18 13"
      fill="none"
    >
      <path
        d="M5.86333 10.1144V9.68889C5.86333 9.13956 6.14081 8.69711 6.69578 8.36156C7.25074 8.026 7.97607 7.85822 8.87178 7.85822C9.76748 7.85822 10.4928 8.026 11.0478 8.36156C11.6027 8.69711 11.8802 9.13956 11.8802 9.68889V10.1144H5.86333ZM8.87178 7.106C8.46259 7.106 8.10963 6.95756 7.81289 6.66067C7.516 6.36378 7.36756 6.01082 7.36756 5.60178C7.36756 5.19259 7.516 4.83956 7.81289 4.54267C8.10963 4.24593 8.46259 4.09756 8.87178 4.09756C9.28096 4.09756 9.63393 4.24593 9.93067 4.54267C10.2276 4.83956 10.376 5.19259 10.376 5.60178C10.376 6.01082 10.2276 6.36378 9.93067 6.66067C9.63393 6.95756 9.28096 7.106 8.87178 7.106ZM0.888889 3.30089V10.5453C1.01644 10.8176 1.30244 11.0641 1.74689 11.2847C2.19133 11.5051 2.73156 11.6695 3.36756 11.7778V4.28889C2.79082 4.18059 2.29652 4.04415 1.88467 3.87956C1.47267 3.71482 1.14074 3.52193 0.888889 3.30089ZM16.8547 3.29578C16.6028 3.51681 16.2718 3.7097 15.8616 3.87445C15.4513 4.03904 14.9561 4.17548 14.376 4.28378V11.7778C15.012 11.6695 15.5522 11.5051 15.9967 11.2847C16.4411 11.0641 16.7271 10.8176 16.8547 10.5453V3.29578ZM4.25644 12.9144C2.91733 12.7413 1.8817 12.4587 1.14956 12.0667C0.417407 11.6747 0.0342222 11.2006 0 10.6444V2.13156C0 1.42385 0.743852 0.891704 2.23156 0.535111C3.71941 0.178371 5.93282 0 8.87178 0C11.8107 0 14.0241 0.178371 15.512 0.535111C16.9997 0.891704 17.7436 1.42385 17.7436 2.13156V10.6444C17.7093 11.2006 17.3261 11.6747 16.594 12.0667C15.8619 12.4587 14.8262 12.7413 13.4871 12.9144V3.53C14.3453 3.37726 15.0556 3.18437 15.618 2.95133C16.1804 2.7183 16.5704 2.45193 16.788 2.15222C16.3219 1.72941 15.4182 1.4123 14.0769 1.20089C12.7356 0.989482 11.0005 0.883778 8.87178 0.883778C6.69741 0.883778 4.91111 0.998 3.51289 1.22644C2.11452 1.45504 1.26207 1.76363 0.955556 2.15222C1.13896 2.45533 1.51193 2.72252 2.07444 2.95378C2.63682 3.18519 3.36415 3.37726 4.25644 3.53V12.9144Z"
        fill={color}
      />
    </svg>
  );
};

export const Cube = ({ color = "#E96F0C" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="19"
      viewBox="0 0 17 19"
      fill="none"
    >
      <path
        d="M7.75 17.0213V9.88275L1.5 6.2635V13.229C1.5 13.2802 1.51283 13.3283 1.5385 13.3733C1.56417 13.4181 1.60258 13.4565 1.65375 13.4885L7.75 17.0213ZM9.25 17.0213L15.3462 13.4885C15.3974 13.4565 15.4358 13.4181 15.4615 13.3733C15.4872 13.3283 15.5 13.2802 15.5 13.229V6.2635L9.25 9.88275V17.0213ZM8.5 8.5905L14.675 5.02125L8.65375 1.5385C8.60258 1.5065 8.55133 1.4905 8.5 1.4905C8.44867 1.4905 8.39742 1.5065 8.34625 1.5385L2.325 5.02125L8.5 8.5905ZM0.904 14.8057C0.619333 14.6418 0.3975 14.4226 0.2385 14.1483C0.0794998 13.8738 0 13.5724 0 13.2443V5.65975C0 5.33158 0.0794998 5.03025 0.2385 4.75575C0.3975 4.48142 0.619333 4.26225 0.904 4.09825L7.59625 0.246251C7.88075 0.0820842 8.182 0 8.5 0C8.818 0 9.11925 0.0820842 9.40375 0.246251L16.096 4.09825C16.3807 4.26225 16.6025 4.48142 16.7615 4.75575C16.9205 5.03025 17 5.33158 17 5.65975V13.2443C17 13.5724 16.9205 13.8738 16.7615 14.1483C16.6025 14.4226 16.3807 14.6418 16.096 14.8057L9.40375 18.6578C9.11925 18.8219 8.818 18.904 8.5 18.904C8.182 18.904 7.88075 18.8219 7.59625 18.6578L0.904 14.8057Z"
        fill={color}
      />
    </svg>
  );
};

export const ChartIcon = ({ color = "#8E98C7" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        d="M3.8655 13.25H5.36525V6.75H3.8655V13.25ZM7.75 13.25H9.25V3.75H7.75V13.25ZM11.6348 13.25H13.1345V9.75H11.6348V13.25ZM1.80775 17C1.30258 17 0.875 16.825 0.525 16.475C0.175 16.125 0 15.6974 0 15.1923V1.80775C0 1.30258 0.175 0.875 0.525 0.525C0.875 0.175 1.30258 0 1.80775 0H15.1923C15.6974 0 16.125 0.175 16.475 0.525C16.825 0.875 17 1.30258 17 1.80775V15.1923C17 15.6974 16.825 16.125 16.475 16.475C16.125 16.825 15.6974 17 15.1923 17H1.80775ZM1.80775 15.5H15.1923C15.2692 15.5 15.3398 15.4679 15.4038 15.4038C15.4679 15.3398 15.5 15.2692 15.5 15.1923V1.80775C15.5 1.73075 15.4679 1.66025 15.4038 1.59625C15.3398 1.53208 15.2692 1.5 15.1923 1.5H1.80775C1.73075 1.5 1.66025 1.53208 1.59625 1.59625C1.53208 1.66025 1.5 1.73075 1.5 1.80775V15.1923C1.5 15.2692 1.53208 15.3398 1.59625 15.4038C1.66025 15.4679 1.73075 15.5 1.80775 15.5Z"
        fill={color}
      />
    </svg>
  );
};

export const XAxisDrawerIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M7 7.5H17C17.8284 7.5 18.5 8.17157 18.5 9V15C18.5 15.8284 17.8284 16.5 17 16.5H7C6.17157 16.5 5.5 15.8284 5.5 15V9C5.5 8.17157 6.17157 7.5 7 7.5Z"
        stroke="#242424"
      />
      <path
        d="M18.5 12.5V15C18.5 15.8284 17.8284 16.5 17 16.5H7C6.17157 16.5 5.5 15.8284 5.5 15V12.5H18.5Z"
        stroke="#242424"
      />
    </svg>
  );
};
export const CalendarIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="19"
      viewBox="0 0 16 19"
      fill="none"
      className="w-6 h-6"
    >
      <path
        d="M1.6155 18.2307C1.15517 18.2307 0.770833 18.0766 0.4625 17.7682C0.154167 17.4599 0 17.0756 0 16.6152V3.84625C0 3.38592 0.154167 3.00158 0.4625 2.69325C0.770833 2.38492 1.15517 2.23075 1.6155 2.23075H3.3845V0H4.4615V2.23075H11.6155V0H12.6155V2.23075H14.3845C14.8448 2.23075 15.2292 2.38492 15.5375 2.69325C15.8458 3.00158 16 3.38592 16 3.84625V16.6152C16 17.0756 15.8458 17.4599 15.5375 17.7682C15.2292 18.0766 14.8448 18.2307 14.3845 18.2307H1.6155ZM1.6155 17.2307H14.3845C14.5385 17.2307 14.6796 17.1667 14.8077 17.0385C14.9359 16.9103 15 16.7692 15 16.6152V7.84625H1V16.6152C1 16.7692 1.06408 16.9103 1.19225 17.0385C1.32042 17.1667 1.4615 17.2307 1.6155 17.2307ZM1 6.846H15V3.84625C15 3.69225 14.9359 3.55117 14.8077 3.423C14.6796 3.29483 14.5385 3.23075 14.3845 3.23075H1.6155C1.4615 3.23075 1.32042 3.29483 1.19225 3.423C1.06408 3.55117 1 3.69225 1 3.84625V6.846ZM8 11.3845C7.79367 11.3845 7.61383 11.3079 7.4605 11.1547C7.30733 11.0016 7.23075 10.8217 7.23075 10.6152C7.23075 10.4089 7.30733 10.2292 7.4605 10.076C7.61383 9.92283 7.79367 9.84625 8 9.84625C8.20633 9.84625 8.38617 9.92283 8.5395 10.076C8.69267 10.2292 8.76925 10.4089 8.76925 10.6152C8.76925 10.8217 8.69267 11.0016 8.5395 11.1547C8.38617 11.3079 8.20633 11.3845 8 11.3845ZM4 11.3845C3.79367 11.3845 3.61383 11.3079 3.4605 11.1547C3.30733 11.0016 3.23075 10.8217 3.23075 10.6152C3.23075 10.4089 3.30733 10.2292 3.4605 10.076C3.61383 9.92283 3.79367 9.84625 4 9.84625C4.20633 9.84625 4.38617 9.92283 4.5395 10.076C4.69267 10.2292 4.76925 10.4089 4.76925 10.6152C4.76925 10.8217 4.69267 11.0016 4.5395 11.1547C4.38617 11.3079 4.20633 11.3845 4 11.3845ZM12 11.3845C11.7937 11.3845 11.6138 11.3079 11.4605 11.1547C11.3073 11.0016 11.2308 10.8217 11.2308 10.6152C11.2308 10.4089 11.3073 10.2292 11.4605 10.076C11.6138 9.92283 11.7937 9.84625 12 9.84625C12.2063 9.84625 12.3862 9.92283 12.5395 10.076C12.6927 10.2292 12.7693 10.4089 12.7693 10.6152C12.7693 10.8217 12.6927 11.0016 12.5395 11.1547C12.3862 11.3079 12.2063 11.3845 12 11.3845ZM8 15.2308C7.79367 15.2308 7.61383 15.1542 7.4605 15.001C7.30733 14.8478 7.23075 14.668 7.23075 14.4615C7.23075 14.2552 7.30733 14.0753 7.4605 13.922C7.61383 13.7688 7.79367 13.6922 8 13.6922C8.20633 13.6922 8.38617 13.7688 8.5395 13.922C8.69267 14.0753 8.76925 14.2552 8.76925 14.4615C8.76925 14.668 8.69267 14.8478 8.5395 15.001C8.38617 15.1542 8.20633 15.2308 8 15.2308ZM4 15.2308C3.79367 15.2308 3.61383 15.1542 3.4605 15.001C3.30733 14.8478 3.23075 14.668 3.23075 14.4615C3.23075 14.2552 3.30733 14.0753 3.4605 13.922C3.61383 13.7688 3.79367 13.6922 4 13.6922C4.20633 13.6922 4.38617 13.7688 4.5395 13.922C4.69267 14.0753 4.76925 14.2552 4.76925 14.4615C4.76925 14.668 4.69267 14.8478 4.5395 15.001C4.38617 15.1542 4.20633 15.2308 4 15.2308ZM12 15.2308C11.7937 15.2308 11.6138 15.1542 11.4605 15.001C11.3073 14.8478 11.2308 14.668 11.2308 14.4615C11.2308 14.2552 11.3073 14.0753 11.4605 13.922C11.6138 13.7688 11.7937 13.6922 12 13.6922C12.2063 13.6922 12.3862 13.7688 12.5395 13.922C12.6927 14.0753 12.7693 14.2552 12.7693 14.4615C12.7693 14.668 12.6927 14.8478 12.5395 15.001C12.3862 15.1542 12.2063 15.2308 12 15.2308Z"
        fill="#242424"
      />
    </svg>
  );
};
